import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Transportista/imprimirTransportistas`, method: 'POST', body: list, token: token})
}
